import React, {useState} from "react";
import {message, Space} from "antd";
import cx from 'classnames';
import styles from "@/page-components/detail/Intro/styles.module.less";
import MobileComponentWrapper from "@/components/MobileComponentWrapper";
import PcComponentWrapper from "@/components/PcComponentWrapper";

type TIntroComponent={
  icon:string;
  title:string;
  english_title:string;
  href?: string;
}

const IntroComponent:React.FC<TIntroComponent> = ({href,icon,title,english_title}) => {
  const [active, setActive] = useState(false);
  return (
    <div
      style={{width: '100%'}}
      onClick={() => {
        if (href){
          console.log(href);
          window.open(href);
        } else {
          message.warning('暂无内容');
        }
      }}
      onMouseEnter={() => {
        setActive(true)
      }}
      onMouseLeave={() => {
        setActive(false)
      }}
    >
      <MobileComponentWrapper>
        <>
          <img alt="" src={icon} className={styles.icon}/>
          <p>{title}</p>
        </>
      </MobileComponentWrapper>
      <PcComponentWrapper>
        <div className={styles.navigate_item}>
          <Space size={16}>
            <div>
              <img alt="" src={icon} className={styles.navigate_item_icon}/>
            </div>
            <div>
              <p className={cx(styles.navigate_item_title,active ? styles.navigate_item_title_active : styles.navigate_item_title_normal)}>{title}</p>
              <p className={styles.navigate_item_subtitle}>{english_title}</p>
            </div>
          </Space>
          <div>
            <img alt="" src={active ? '/img/ico_xq_arrow_active.png' : '/img/ico_xq_arrow.png'} className={styles.navigate_item_icon_small}/>
          </div>
        </div>
      </PcComponentWrapper>
    </div>
  )
}
export default IntroComponent;
